import { mediaModalActions } from 'base/common/media-modal/slice';
import {
  all, call, put, select, takeEvery,
} from 'redux-saga/effects';
import { request } from 'utils/request';
import { IRestApiResponse } from 'interfaces';
import { selectEnterprise } from 'base/core/selectors';
import { viewContentActions } from './slice';
import API from './constants';
import {
  IContentDocument,
  ICreateContentModalStateAction,
  IDeleteContentModalStateAction,
} from './interface';

export function* createContentGenerator({ payload }: ICreateContentModalStateAction): any {
  try {
    const tenant = yield select(selectEnterprise);
    const response: IRestApiResponse = yield call(
      request,
      API.CREATE_EXPERT_CONTENT,
      { ...payload, entId: tenant.id },
      true,
    );
    if (response.statusCode === 201) {
      yield put(viewContentActions.createContentSucceeded(response.data as IContentDocument));
      yield put(mediaModalActions.addUploadedMedia(response.data as IContentDocument));
    } else {
      yield put(viewContentActions.createContentFailed());
    }
  } catch (error) {
    yield put(viewContentActions.createContentFailed());
  }
}
export function* deleteContentGenerator({ payload }: IDeleteContentModalStateAction): any {
  try {
    const response: IRestApiResponse = yield call(
      request,
      API.DELETE_CONTENT,
      { ...payload },
      true,
    );
    if (response.statusCode === 201) {
      yield put(viewContentActions.deleteContentSucceeded(payload.id));
    } else {
      yield put(viewContentActions.deleteContentFailed());
    }
  } catch (error) {
    yield put(viewContentActions.deleteContentFailed());
  }
}

export function* viewContentSaga() {
  yield all([
    takeEvery(viewContentActions.createContent.type, createContentGenerator),
    takeEvery(viewContentActions.deleteContent.type, deleteContentGenerator),
  ]);
}

export default viewContentSaga;
